
import { Component, Prop, Mixins } from 'vue-property-decorator';
import WhiteLabelMixin from '../mixins/whiteLabelMixin';

@Component
export default class DefaultPageLayout extends Mixins(WhiteLabelMixin) {
  @Prop({
    required: false,
    default: () => ({
      'padding-top': '68px',
      'padding-bottom': '70px',
    }),
  }) headerStyle!: { [key: string]: string };

  get headerStyleCombined(): { [key: string]: string } {
    return {
      'padding-top': '68px',
      'padding-bottom': '70px',
      ...this.headerStyle,
    };
  }
}
